import Button from '@ramsey-design-system/button';
import { useMatcherButtonSize } from '../utils';

interface Props {
  onSkip: () => void | Promise<void>;
  buttonText: string;
  disabled?: boolean;
}

function MatcherSkipButton({
  onSkip,
  buttonText,
  disabled = false
}: Readonly<Props>) {
  const buttonSize = useMatcherButtonSize();

  return (
    <div className="flex justify-center mt-1">
      <Button
        data-testid="matcher_skip_button"
        type="button"
        appearance="subtle"
        size={buttonSize}
        className="w-full!"
        fullWidthOnMobile={true}
        onClick={onSkip}
        disabled={disabled}
      >
        {buttonText}
      </Button>
    </div>
  );
}

export { MatcherSkipButton };
